import React from 'react';

/**
 * Specialized component for rendering academic publications
 * Handles the specific structure and formatting of publication entries
 */
const PublicationsList = ({ publications, title = 'Publications' }) => {
  if (!publications || !publications.length) return null;

  return (
    <div>
      <span>{title}</span>
      <ul>
        {publications.map((publication, index) => (
          <li key={index}>
            "{publication.title}" <br />
            <a 
              href={publication.url} 
              target='_blank' 
              rel='noreferrer'
              aria-label={`Read ${publication.title} published in ${publication.journal}`}
            >
              {publication.journal}, {publication.year}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PublicationsList;